import clientTranslations from "@src/modules/client/_langs/en-US";
import memberTranslations from "@src/modules/member/_langs/en-US";
import { rayaLucariaEnUS } from "@src/raya-lucaria/i18n";
import { geoEnUS } from "@src/raya-lucaria/utils/geo-i18n-en-US";

export default {
  countries: geoEnUS.countries,
  states: geoEnUS.states,
  currencies: {
    USD: "US Dollar",
    CAD: "Canadian Dollar",
  },

  clientM: clientTranslations,
  member: memberTranslations,
  wizard: {
    stepPosition: "Step {{current}} of {{total}}: {{label}}",
    stepName: "Step {{n}} of {{total}}, {{label}}",
    stepNameCompleted: "Step {{n}} of {{total}}, {{label}}, completed",
    stepNameSkipped: "Step {{n}} of {{total}}, {{label}}, skipped",
    next: "Next",
    nextTo: "Next: {{step}}",
    backTo: "Back to {{step}}",
    continueTo: "Continue to {{step}}",
    blocked_one: "1 problem on this step. Fix it to continue.",
    blocked_other: "{{count}} problems on this step. Fix them to continue.",
    blockedUnknown: "This step has problems. Fix them to continue.",
    opensInNewTab: "(opens in a new tab)",
  },
  controls: {
    combobox: {
      selectAll: "Select all",
      deselectAll: "Deselect all",
      clear: "Clear",
      selected: "{{count}} selected",
      more: "+{{count}} more",
      showLess: "Show less",
      empty: "No results",
      searchPlaceholder: "Search…",
      create: "Create",
      unavailable: "Unavailable",
      loading: "Loading…",
      clearAll: "Clear all selections",
      removeOption: "Remove {{label}}",
      optionRemoved: "Removed: {{label}}",
      selectionCleared: "Selection cleared",
      resultOne: "1 result available",
      resultMany: "{{count}} results available",
      createOption: "Create “{{label}}”, new entry",
      created: "Created and selected: {{label}}",
    },
  },
  validation: {
    required: "{{value}} is required",
    requiredField: "{{field}} is required",
    maxValue: "The value of {{value}} cannot be more than {{max}}",
    minValue: "The value of {{value}} cannot be less than {{min}}",
    noSpacesAllowed: "No spaces allowed in {{value}}",
  },

  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",

  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",

  addInvoice: "Add Invoice",
  addNewInvoiceToClient: "Add a new invoice to this client",
  address: "Address",
  addressLineOne: "Address Line One",
  addressLineTwo: "Address Line Two",
  inviteTeamMember: "Invite Team Member",
  amount: "Amount",
  amountDue: "Amount Due",
  accept: "Accept",
  actions: "Actions",
  city: "City",
  confirmPassword: "Confirm Password",
  newPassword: "New Password",
  oldPassword: "Old Password",
  changePassword: "Change Password",
  twoFactorAuth: "Two Factor Authentication",
  twoFactorAuthNotEnabled: "Two factor authentication is not enabled",
  twoFactorAuthEnabled: "Two factor authentication is enabled",
  enable2faBtnText: "Enable Two-Factor Authentication",
  disable2faBtnText: "Disable Two-Factor Authentication",
  twoFactorAuthDesc:
    "Two-factor authentication adds an extra layer of security to your account.",
  country: "Country",
  clients: "Clients",
  copyPaymentLink: "Copy Payment Link",
  copyPaymentLinkUnavailable:
    "Available when Stripe is connected as the payment gateway",
  copy2FaCode: "Copy code",
  twoFaCodeCopied: "Copied",
  dismissNotification: "Dismiss notification",
  notificationsRegion: "Notifications",
  code: "Code",
  createAnAccountWithStripe: "Create a Stripe Connected Account",
  cropImageDescription:
    "Drag the image to move it, or use the arrow keys or the Move buttons. Use the scroll wheel, the plus and minus keys or the Zoom slider to zoom.",
  cropImageFailed:
    "Sorry, this image could not be prepared for upload. Try again, or choose a smaller image.",
  cropArea: "Crop area",
  cropAreaInstructions:
    "Use the arrow keys to move the image, Shift for larger steps, plus and minus to zoom.",
  cropMoveLeft: "Move left",
  cropMoveRight: "Move right",
  cropMoveUp: "Move up",
  cropMoveDown: "Move down",
  cropZoom: "Zoom",
  cropZoomValue: "{{percent}} percent",
  cropZoomAnnouncement: "Zoom {{percent}} percent. {{position}}",
  cropImageCentred: "Image centred",
  cropPositionOne: "Image {{first}} of centre",
  cropPositionTwo: "Image {{first}} and {{second}} of centre",
  cropOffsetLeft: "{{percent}} percent left",
  cropOffsetRight: "{{percent}} percent right",
  cropOffsetUp: "{{percent}} percent up",
  cropOffsetDown: "{{percent}} percent down",
  cropOrganizationImage: "Crop Organization Image",
  cropInvoiceLogo: "Crop Invoice Logo",
  cropProfileImage: "Crop Profile Image",
  client: "Client",
  clientEmail: "Client Email",
  clientName: "Client Name",
  clientPhone: "Client Phone",
  continue: "continue",
  createNewAccount: "Create a new account",
  createNewClient: "Create New Client",
  createOrganization: "Create Organization",
  clientList: "Client List",
  decline: "Decline",
  delete: "Delete",
  deleteImage: "Delete Image",
  deleteItem: "Delete Item",
  deleteOrganizationImageMessage:
    "Are you sure you want to delete your organization image?",
  deleteProfileImageTitle: "Delete Profile Image",
  deleteProfileImageMessage:
    "Are you sure you want to delete your profile image?",
  details: "Details",
  discard: "Discard",
  download: "Download",
  edit: "Edit",
  email: "Email",
  erroredWhileCreatingStripeConnectedAccount:
    "An error occurred while creating your Stripe account. Please try again later or contact support if the issue persists.",
  erroredWhileFetchingStripeAccount:
    "An error occurred while trying to fetch Stripe account information. Not to worry. We get notified about issues like these it will be fixed momentarily.",
  firstName: "First Name",
  id: "ID",
  image: "Image",
  invalidPhoneNumberErrorMessage:
    "Invalid phone number format. No spaces allowed. Must start with + followed by country code and phone number. Eg: +16482431768",
  invoiceActions: "Invoice Actions",
  invoiceAlreadyPaid: "Invoice already paid",
  invoiceCount: "Invoice Count",
  invoiceDate: "invoice date",
  invoiceDueDate: "invoice due date",
  invoiceInfo: "Invoice Info",
  invoiceIsPastDue: "Invoice is past due",
  invoiceIsPaidWarning: "This invoice is already paid",
  invoiceNumber: "Invoice Number",
  invoicePaymentProcessorInfo:
    "Select the payment processor to be used in collecting payment for this invoice. Please note that different payment processors have different fees.",
  invoices: "Invoices",
  inventory: "Inventory",
  oms: "OMS",
  lastName: "Last Name",
  lineItemCount: "Line Item Count",
  maxLengthFieldErrorMessage:
    "This field has exceeded the maximum number of characters.",
  maxLengthWithValueFieldErrorMessage:
    "This field can only accept {{value}} character(s).",
  memberActionMenu: "{{name}} Action Menu",
  name: "Name",
  newEntity: "New {{entityName}}",
  newEntityDescription: "Create a new {{entityName}}",
  newInvoiceItem: "New Invoice Item",
  noInvoicesForClient: "No invoices available for this client",
  notPaid: "Not Paid",
  noTeamMembers: "No team members",
  organizationImage: "Organization Image",
  organizationIsNotConfiguredToAcceptPayments:
    "Organization is not configured to accept payments",
  paid: "Paid",
  passOnProcessingFee: "Pass on Processing Fee",
  passOnProcessingFeeInfo:
    "We collect a small processing fee of {{ processingFee }} to support our seamless invoicing services. You can choose to pass this fee to your clients by enabling this toggle, which adds it directly to their invoice total. This helps us continue providing features like automation and transaction management, ensuring a smooth experience for you.",
  password: "Password",

  paymentGateway: "Payment Gateway",
  paymentInstructions: "Payment Instructions",
  paymentLinkCopied: "Payment link copied",
  paymentProcessor: "Payment Processor",
  payNow: "Pay {{amount}} Now",
  percentageBased: "Percentage Based",
  percentageBasedInfo: "Is this surcharge percentage based or a flat rate?",
  pendingInvitations: "Pending Invitations",
  help: {
    label: "Help",
    opensInNewTab: "(opens in a new tab)",
  },
  poweredBy: "Powered by",
  processingFee: "Processing Fee",
  phone: "Phone",
  profile: "Profile",
  save: "Save",
  saveImage: "Save Image",
  send: "Send",
  sendInvitation: "Send Invitation",
  sendInvoiceNoItemWarning:
    "This invoice has no items. Are you sure you want to send it now? This action cannot be undone.",
  sentOn: "Sent {{date, MM/DD/YYYY}}",
  settings: "Settings",
  accountMenu: "Account and organization menu",
  accountMenuFor: "Account and organization menu: {{organization}}",
  currentOrganizationIs: "Current organization: {{organization}}",
  switchedToOrganization: "Switched to {{organization}}.",
  state: "State/Province",
  stripe: {
    requirements: {
      external_account: "Bank Account",
      business_profile: {
        mcc: "Merchant Category Code",
        product_description: "Business Description",
        support_phone: "Support Phone",
        url: "Business Website URL",
      },
      business_type: "Business Type",
      representative: {
        dob: {
          day: "Representative Date of Birth",
          month: "Representative Month of Birth",
          year: "Representative Year of Birth",
        },
        email: "Representative Email",
        first_name: "Representative First Name",
        last_name: "Representative Last Name",
      },
      tos_acceptance: {
        date: "Terms of Service Acceptance Date",
        ip: "Terms of Service Acceptance",
      },
    },
  },
  search: "Search",
  stripeAccount: "Stripe Account",
  stripeAccountInformation: "Stripe Account Information",
  stripeConnectedAccountAlreadyExists:
    "Stripe connected account already exists for this organization.",
  stripePendingRequirements: "Stripe Pending Requirements",
  subtotal: "Subtotal",
  successfulInvoiceUpdate: "Invoice updated successfully",
  successfullyCreatedAStripeConnectedAccount:
    "Successfully created a Stripe connected account",
  successfulTeamMemberInvitation: "Team member invitation sent successfully",
  successfulTeamMemberInvitationResend: "Invitation resent",
  successfulTeamMemberInvitationCancel: "Invitation cancelled",
  successfulTeamMemberInvitationDelete: "Invitation deleted",
  successfulTeamMemberInvitationsBulkDelete: "Invitations deleted",
  successfulRoleDelete: "Role deleted",
  surcharge: "Surcharge",
  surcharges: "Surcharges",
  surchargeCreated: "Surcharge created successfully",
  surchargeDeleted: "Surcharge deleted successfully",
  surchargeUpdated: "Surcharge updated successfully",
  switchOrganization: "Switch Organization",
  switchOrganizationMessage:
    "Select the organization you would like to switch to.",
  switchOrganizationTo: "Switch to organization {{organization}}",
  teamMemberInvitation: "Team Member Invitation",
  total: "Total",
  transactions: "Transactions",
  type: "Type",
  updatedYourStripeAccount: "Updated your connected Stripe account",
  zip: "Zip/Postal Code",
  date: "Date",
  description: "Description",
  emptyList: "No data available",
  general: "General",
  "creating...": "Creating...",
  sorryAnErrorOccurred: "Sorry, an error occurred",
  getStartedTitle: "Let's get you started",
  getStartedMessage: "Create your first organization to get started!",
  createNewOrganizationTitle: "Create a new organization",
  createNewOrganizationMessage: "Add another organization to your account",
  incompleteStripeConfiguration: "Incomplete Stripe Configuration",
  items: "Items",
  logout: "Logout",
  teamMembers: "Team Members",
  new: "New",
  organizationName: "Organization name",
  organizationSettings: "Organization Settings",
  organizationsListLoadError:
    "Error loading organizations list. Please try again later.",
  pageInfo: "Showing {{currentPage}} of {{totalPages}} | Per Page: {{perPage}}",
  paymentProcessorNotSupported: "Payment processor not supported",
  pleaseProvideEmail: "Please provide your email address to sign in",
  pleaseProvideEmailToCreateAccount:
    "Please provide your email address to create an account",
  price: "Price",
  unitPrice: "Unit Price",
  profileSettings: "Profile Settings",
  quantity: "Quantity",
  rate: "Rate",
  requiredFieldErrorMessage: "{{value}} is required.",
  readyForUse: "Ready for use",
  selectedRows: "{{value}} selected row(s)",
  sku: "SKU",
  tagLine: "Tag Line",
  useExitingAccount: "Sign in with existing account",
  welcomeBack: "Log into Invup",
  welcomeToInvup: "Welcome to invup",
  invoiceNo: "No",
  currency: "Currency",
  dueDate: "Due Date",
  invoiceList: "Invoice List",
  qty: "QTY",
  newClient: "New Client",
  passwordMismatch: "Passwords do not match",
  passwordPattern:
    "Password must contain at least one lowercase, one uppercase, one number, and one special character",
  minLength: "This field must be at least {{value}} characters long",
  "- none -": "- none -",
  passwordChangeSuccess: "Password changed successfully",
  passwordChangeFailed: "Failed to change password",
  invoiceDownloadFailed: "Failed to download invoice",
  invoiceDownloadSuccess: "Invoice downloaded successfully",
  downloadingInvoice: "Downloading invoice...",
  downloadingReceipt: "Downloading receipt...",
  receiptDownloadSuccess: "Receipt downloaded successfully",
  viewList: "View list",
  duplicate: "Duplicate",
  invoiceDuplicateSuccess: "Invoice duplicated successfully",
  invoiceDuplicateFailed: "Failed to duplicate invoice",
  duplicateInvoice: "Duplicate Invoice",
  duplicateConfirmationMessage:
    "Are you sure you want to duplicate this invoice?",
  deleteImageError: "Failed to delete image",
  modules: {
    member: {
      invitationDecision: {
        sorryThisInvitationDoesNotMatchYourAccount:
          "Sorry, it looks like you are logged in with a different account",
        pleaseLoginWithTheCorrectAccountToAcceptThisInvitation:
          "Please login with the correct account to accept this invitation.",
        dashboard: "Go to my Dashboard",
        logout: "Logout and Login with correct account",
        invitationDecision: "Invitation Decision",
        alreadyMember: "Already a member",
        looksLikeYouAreAlreadyAMember:
          "Looks like you are already a member of {{organizationName}}",
        invitationMessage:
          "You have been invited to join {{organizationName}} by {{inviterName}}",
        pleaseLogin:
          "{{inviterName}} has invited you to join {{organizationName}}. Please login to accept the invitation.",
        pleaseSignUp:
          "{{inviterName}} has invited you to join {{organizationName}}. Please sign up to accept the invitation.",
        someone: "Someone",
        invitationAcceptedSuccessfully: "Invitation accepted",
        invitationDeclinedSuccessfully: "Invitation declined",
      },
    },
  },

  genericErrorMessage: "An error occurred. Please try again later.",
  notFound: "Sorry, we could not find what you are looking for",
  pageNotFound: "Page not found.",
  featureNotAvailable: "Feature not available on this account",
  featureNotAvailableUpgradeCta: "Upgrade to Pro",
  permissionDenied: "You don't have permission to access this section",
  portalAccessDeniedTitle:
    "You don't have access to this organization's portal",
  portalAccessDeniedDescription:
    "Switch to a different organization or create a new one to get started.",
  resourceAccessDeniedTitle: "You don't have access to this page",
  resourceAccessDeniedDescription:
    "Your current role doesn't include permission to view this resource. Contact your organization admin if you need access.",
  takeMeHome: "Take me home",
  tryAgain: "Try again",
  goBack: "Go back",
  feesAndTaxes: "Fees and Taxes",
  taxes: "Taxes",
  yes: "Yes",
  no: "No",
  timeline: {
    empty: "No activity yet",
    relative: {
      now: "just now",
      minutes: "{{count}}m ago",
      hours: "{{count}}h ago",
      days: "{{count}}d ago",
      weeks: "{{count}}w ago",
      months: "{{count}}mo ago",
    },
    feedLabel_one: "Activity timeline, {{count}} event",
    feedLabel_other: "Activity timeline, {{count}} events",
    announce: {
      range_one: "Showing event {{start}}.",
      range_other: "Showing events {{start}} to {{end}}.",
      rangeOfTotal_one: "Showing event {{start}} of {{total}}.",
      rangeOfTotal_other: "Showing events {{start}} to {{end}} of {{total}}.",
      results_one: "{{count}} event found.",
      results_other: "{{count}} events found.",
      resultsMore_one: "Showing the first {{count}} event; more are available.",
      resultsMore_other:
        "Showing the first {{count}} events; more are available.",
      noMatches: "No events match these dates.",
      loadFailed: "Activity could not be loaded.",
      refreshed: "Activity refreshed.",
      refreshedNew_one: "Activity refreshed. {{count}} new event.",
      refreshedNew_other: "Activity refreshed. {{count}} new events.",
      refreshedNoChange: "Activity refreshed. Nothing changed.",
      refreshFailed: "Activity could not be refreshed.",
    },
    loading: "Loading…",
    refresh: "Refresh activity",
    filters: {
      from: "From",
      to: "To",
      reset: "Reset",
    },
    pagination: {
      previous: "Previous",
      next: "Next",
    },
  },
  activity: {
    title: "Activity",
    description:
      "A timeline of changes across this organization — who did what, and when.",
  },
  teamMemberDetails: {
    activityHeading: "Activity",
  },
  ...rayaLucariaEnUS,
};
